__turbopack_context__.v({
  "buttonContainer": "PaginatedList-module__1rAsCa__buttonContainer",
  "container": "PaginatedList-module__1rAsCa__container",
  "grid": "PaginatedList-module__1rAsCa__grid",
  "pageNumber": "PaginatedList-module__1rAsCa__pageNumber",
  "pagination": "PaginatedList-module__1rAsCa__pagination",
});
